export default __webpack_public_path__ + "static/book1111-9f1f0b80d9dac55a526ac92685de3bec.png";